import { useQuery, useQueryClient } from "@tanstack/react-query";
import { EndpointsService } from "../services/endpoints/endpoints.service";

export const useMarketingCampaigns = (participantId: number) => {
	const queryClient = useQueryClient();
	const queryKey = ["marketing-campaigns", participantId];

	const query = useQuery({
		queryKey: queryKey,

		queryFn: async () => {
			const response = await EndpointsService.dataRetriever.getPatientCampaignStatus({
				patientId: participantId,
			});
			return response;
		},
	});

	return {
		...query,
		invalidate: () =>
			queryClient.invalidateQueries({
				queryKey: queryKey,
			}),
	};
};
